import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';
import { TV_QR_IMAGE, TV_QR_SUBTITLE } from '../../data/tvDemoDisplay';
import tvTheme, { tvTextStroke } from './tvTheme';

/** 全フレーム共通：右上固定の QR 導線 */
function TVQrOverlay({ compact = false }) {
  const qrSize = compact ? 64 : 92;
  const labelSize = compact ? '0.58rem' : 'clamp(0.72rem, 1.15vw, 0.95rem)';

  return (
    <Box
      sx={{
        position: 'absolute',
        top: compact ? 4 : 8,
        right: compact ? 4 : 8,
        zIndex: 12,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: compact ? 0.22 : 0.28,
        px: compact ? 0.45 : 0.6,
        py: compact ? 0.4 : 0.55,
        bgcolor: 'rgba(255,255,255,0.96)',
        border: '3px solid #fff',
        borderRadius: 0.75,
        boxShadow: '0 4px 18px rgba(13,74,143,0.24)',
        pointerEvents: 'none',
        minWidth: compact ? 108 : 148,
      }}
      aria-label={TV_QR_SUBTITLE}
    >
      <Typography
        sx={{
          fontSize: labelSize,
          fontWeight: 900,
          color: tvTheme.colors.accentBlue,
          lineHeight: 1.2,
          textAlign: 'center',
          whiteSpace: 'nowrap',
          ...tvTextStroke('#fff'),
        }}
      >
        {TV_QR_SUBTITLE}
      </Typography>
      <Box
        component="img"
        src={TV_QR_IMAGE}
        alt=""
        sx={{
          width: qrSize,
          height: qrSize,
          display: 'block',
          borderRadius: 0.35,
        }}
      />
    </Box>
  );
}

TVQrOverlay.propTypes = {
  compact: PropTypes.bool,
};

export default TVQrOverlay;
